import { InjectionToken } from '@angular/core';

import { BarLayoutState } from './bar-layout-state.contract';

export const BAAS_LAYOUT_STATE = new InjectionToken<BarLayoutState>('Layout settings');

export const BAAS_LAYOUT_GVK = new InjectionToken<boolean>('Layout GVK enabled');
